<template>
  <div>
    <div class="menu" id="menu">
      <div class="content1">
        <!-- <div class="logo">
          <router-link to="/">千种药用植物基因组数据库</router-link>
        </div> -->
        <div class="btn">
          <!-- <el-menu class="el-menu-demo" mode="horizontal">
            <el-menu-item index="1" class="black"><router-link to="/">Home</router-link></el-menu-item>
            <span></span>
            <el-menu-item index="3"><router-link to="/blastcenter">Blast</router-link></el-menu-item>
             <el-menu-item index="4">|</el-menu-item>
            <el-menu-item index="5"><router-link to="/primer">Primer design</router-link> </el-menu-item>
            <el-menu-item index="3"><router-link to="/download">Download</router-link></el-menu-item>
          </el-menu> -->
          <ul>
            <li class="black"><router-link to="/">Home</router-link></li>
            <li class="ww">|</li>
            <li><router-link to="/blastcenter">Blast</router-link></li>
            <li class="ww">|</li>
            <li><router-link to="/primer">Primer design</router-link></li>
          </ul>
        </div>
      </div>
    </div>
    <div class="contenter">
      <div class="ttitle">
        <img src="../../../assets/u77.png" width="30" />
        <span>Membership service</span>
      </div>
      <div class="item">
        <div class="title">
          <span>1.Gene family analysis</span>
        </div>
        <div class="des">
          A gene family is a class of genes with a common evolutionary ancestor, and members of a gene family are similar in sequence and often have similar biological functions. Gene families are clustered to obtain single-copy gene families and multi-copy gene families, shared gene families and unique gene families. The shared gene families may be conserved genes for survival, while the unique genes may be related to the biological characteristics of the species and the survival environment. Through GO and KEGG functional enrichment analysis, we can analyze in which GO terms and KEGG pathways shared gene families and endemic gene families are enriched, and explain the formation of important biological properties of target species at the genetic level, as well as the adaptive evolutionary mechanisms in specific survival environments.
        </div>
        <div class="img">
          <img src="../../../assets/server1.png" width="500px" /><br /><br />
          <span>Sample results of shared and unique gene family analysis </span><br />
        </div>
      </div>
      <div class="item">
        <div class="title">
          <span>2. Phylogenetic analysis</span>
        </div>
        <div class="des">
          Species phylogenetic trees were constructed using linked gene sequences of single-copy gene families, and the timing of species divergence was estimated from time-corrected points with fossil evidence. Species phylogenetic trees can reveal the evolutionary status of species and the timing of divergence from closely related species, and are important references for understanding species formation.
        </div>
        <div class="img">
          <img src="../../../assets/server2-1.png" width="500px" /><br />
          <img src="../../../assets/server2-2.png" width="500px" /><br /><br />
          <span>Example of phylogenetic analysis results </span><br />
        </div>
      </div>
      <div class="item">
        <div class="title">
          <span>3.Analysis of gene family expansion and <contraction></contraction></span>
        </div>
        <div class="des">
          Based on the gene family clustering results, gene family  expansion and contraction analysis was performed to evaluate the changes in gene families during the evolution of the genome.
        </div>
        <div class="img">
          <img src="../../../assets/server3.png" width="500px" /><br /><br />
          <span>Example of gene family contraction and expansion analysis results </span><br />
        </div>
      </div>
      <div class="item">
        <div class="title">
          <span>4. Whole genome duplications analysis</span>
        </div>
        <div class="des">
          Whole genome duplications (WGDs) events provide the original resources for species, especially plant evolution, and are a prerequisite for adaptive evolution of species. Protein sequences of different species were compared, genomic Synteny blocks were analyzed, and the frequency of synonymous mutations (Ks), non-synonymous mutations (Ka), and the ratio of non-synonymous mutation rate to synonymous mutation rate (Ka/Ks) of covariant gene pairs were calculated to analyze the whole genome duplications events of species and divergence events with closely related species.
        </div>
        <div class="img">
          <img src="../../../assets/server4-1.png" width="500px" /><br />
          <img src="../../../assets/server4-2.png" width="500px" /><br /><br />
          <span>Example of whole genome replication analysis results </span><br />
        </div>
      </div>
      <div class="item">
        <div class="title">
          <span>5.Generate circos figure</span>
        </div>
        <div class="des">
          Circos figure were generate to show the basic structural characteristics of genome chromosomes, gene density, GC content, collinear distribution and so on.
        </div>
        <div class="img">
          <img src="../../../assets/server5.png" width="500px" /><br /><br />
          <span>Circos figure sample </span><br />
        </div>
      </div>
      <div class="item">
        <div class="title">
          <span>6.Selective pressure analysis</span>
        </div>
        <div class="des">
          The protein sequences of single-copy gene families shared by the genome of the target species and several closely related species under comparative analysis are compared in multiple sequences to calculate the gene families under selection in the target species. Through functional enrichment analysis, we can further analyze which GO terms and KEGG pathways are mainly selected, so as to understand which genes and which metabolic pathways in the target species are under natural or artificial selection.
        </div>
      </div>
      <div class="item">
        <div class="title">
          <span>7. Synteny analysis</span>
        </div>
        <div class="des">
          The linkage and sequential conservation of homologous genes at gene seats in two species is called genomic synteny, and synteny analysis facilitates the study of important genes between closely related species. Synteny analysis can reveal chromosomal structural similarities and differences between genomes of genomes and those of closely related species, and search for regions of chromosomal structural variation such as translocations, inversions, insertions and deletions. Synteny analysis of target species can compare the genome structure of related species, deduce the evolutionary history of the first species, and guide the localization and cloning of genes for important known traits.
        </div>
        <div class="img">
          <img src="../../../assets/server7-1.png" width="500px" /><br />
          <img src="../../../assets/server7-2.png" width="500px" /><br />
          <img src="../../../assets/server7-3.png" width="500px" /><br /><br />
          <span>Example synteny analysis diagram </span><br />
        </div>
      </div>
      <div class="item">
        <div class="title">
          <span>8. Metabolic pathway analysis</span>
        </div>
        <div class="des">
          Based on the KEGG pathway database annotation, blast sequence alignment and database comparison of key genes of metabolic pathways targeting specific substances, combined with transcriptomic and metabolomic data, co-expression analysis was performed to predict metabolic substance synthesis pathways and to mine key regulatory candidate genes in metabolic pathways. Combined with genome duplication events and gene family contraction and expansion analysis, we explore their effects on the evolution of the synthesis pathway of target active ingredients.
        </div>
        <div class="img">
          <img src="../../../assets/server8-1.png" width="500px" /><br />
          <img src="../../../assets/server8-2.png" width="500px" /><br /><br />
          <span>Example results of metabolic pathway analysis </span><br />
        </div>
      </div>
      <div class="item">
        <div class="title">
          <span>9. Metabolic pathway gene cluster analysis</span>
        </div>
        <div class="des">
          A gene cluster is a large string of repeating units arranged in tight clusters of members of a gene family, located in a specific region of the chromosome. Gene clusters can be composed of as few as two related genes generated by duplication, or as many as several hundred identical genes arranged in series. They belong to the same ancestral gene amplification product, or there are gene families whose members are not closely arranged on the chromosome and contain some unrelated sequences in between, but are generally distributed in relatively concentrated regions on the chromosome. Related gene families in metabolic pathways often form gene cluster structures that increase the efficiency of expression of key genes in metabolic pathways. The mining of gene clusters can help to resolve the formation of a species-specific metabolic pathway.
        </div>
        <div class="img">
          <img src="../../../assets/server9.png" width="700px" /><br /><br />
          <span>Example results of Metabolic pathway gene cluster analysis </span><br />
        </div>
      </div>
      <div class="item">
        <div class="title">
          <span>10. Weighted correlation network analysis</span>
        </div>
        <div class="des">
          Weighted correlation network analysis (WGCNA) is the use of expression correlation coefficients between molecules to measure their co-expression relationships, where molecules in the same module have similar expression patterns and differ significantly from the expression patterns of molecules in other modules. Molecules with similar expression patterns may be involved in the same biological process or pathway. Thus, complex histological data can be simplified into several functional modules, which are associated with phenotypic information, and biologically meaningful modules can be identified. With the analysis of WGCNA, using a dimensionality reduction approach, thousands of thousands of gene expression profiles can be transformed into co-expression modules, and then the genes in this module can be analyzed in detail to identify genes associated with the target metabolites.
        </div>
        <div class="img">
          <img src="../../../assets/server10.jpg" width="500px" /><br /><br />
          <span>Example results of WGCNA analysis </span><br />
        </div>
      </div>
      <div class="item">
        <div class="title">
          <span>References</span>
        </div>
        <div class="des1">
          Chen J, Hao Z, Guang X, et al. <i>Liriodendron</i> genome sheds light
          on angiosperm phylogeny and species–pair differentiation. Nature
          plants, 2019, 5(1): 18-25.
        </div>
        <div class="des1">
          Guo L, Winzer T, Yang X, et al. The opium poppy genome and morphinan
          production. Science. 2018 Oct 19;362(6412):343-347.
        </div>
        <div class="des1">
          Pu X, Li Z, Tian Y, Gao R, Hao L, et al. The honeysuckle genome
          provides insight into the molecular mechanism of carotenoid metabolism
          underlying dynamic flower coloration. New Phytol. 2020
          Aug;227(3):930-943.
        </div>
        <div class="des1">
          Song C, Liu Y, Song A, et al. The
          <i>Chrysanthemum nankingense</i> genome provides insights into the
          evolution and diversification of chrysanthemum flowers and medicinal
          traits. Molecular plant, 2018, 11(12): 1482-1491.
        </div>
        <div class="des1">
          Song JM, Guan Z, Hu J, et al. Eight high-quality genomes reveal
          pan-genome architecture and ecotype differentiation of Brassica
          <i>napus</i>. Nature Plants. 2020 Jan;6(1):34-45.
        </div>
        <div class="des1">
          Tu L, Su P, Zhang Z, et al. Genome of
          <i>Tripterygium wilfordii</i> and identification of cytochrome P450
          involved in triptolide biosynthesis. Nat Commun. 2020 Feb
          20;11(1):971.
        </div>
        <div class="des1">
          Xie D, Xu Y, Wang J, Liu W, et al. The wax gourd genomes offer
          insights into the genetic diversity and ancestral cucurbit karyotype.
          Nat Commun. 2019 Nov 14;10(1):5158
        </div>
        <div class="des1">
          Zhang J, Fu XX, Li RQ, Zhao X, et al. The hornwort genome and early
          land plant evolution. Nat Plants. 2020 Feb;6(2):107-118.
        </div>
        <div class="des1">
          Zhang X, Wang G, Zhang S, et al. Genomes of the Banyan Tree and
          Pollinator Wasp Provide Insights into Fig-Wasp Coevolution. Cell. 2020
          Nov 12;183(4):875-889.e17.
        </div>
        <div class="des1">
          Mateus ID, Masclaux FG, Aletti C, et al. Dual RNA-seq reveals
          large-scale non-conserved genotype × genotype-specific genetic
          reprograming and molecular crosstalk in the mycorrhizal symbiosis.
          ISME J. 2019 May;13(5):1226-1238.
        </div>
        <br />
        <br />
      </div>
      <div class="lxwm">
        <div class="box">
          <router-link to="/contactus">
            <img src="../../../assets/u81.png" />
            <span>CONTACT US</span>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  created(){
    window.addEventListener("scroll", this.handleScroll);
  },
  methods:{
    handleScroll() {
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      let offsetTop = document.querySelector("#menu").offsetTop;
      let isFixed = scrollTop > offsetTop ? true : false;
      if (isFixed) {
        document.querySelector("#menu").style =
          "position: fixed;top:0;background:#fff;z-index:9999";
      } else {
        document.querySelector("#menu").style = "";
      }
    },
  }
};
</script>
<style scoped>
.lxwm {
  /* border: 1px solid red; */
}
.lxwm .box {
  width: 200px;
  height: 40px;
  border: 2px solid seagreen;

  line-height: 40px;
  text-align: center;
  margin: 0 auto;

  cursor: pointer;
  font-size: 16px;
  font-weight: bold;
}
.lxwm .box a {
  display: flex;
  text-decoration: none;
  color: seagreen;
}
.lxwm .box img {
  width: 35px;
  height: 35px;
  margin: 2.5px 5px 2.5px 45px;
}
.menu {
  width: 100%;
  height: 60px;
  flex: 0;
  border-bottom: 1px solid #ccc;
  margin-bottom: 10px;
  box-shadow: 1px 1px 2px #ccc;
}
.menu .content1 {
  width: 1200px;
  height: 50px;
  margin: 0 auto;
  /* border: 1px solid red; */
}
.menu .black {
  color: #000;
}
.menu .content1 .logo {
  float: left;
  width: 250px;
  height: 50px;
  margin: 5px 0;
  /* border: 1px solid #ccc; */
  line-height: 50px;

  text-align: center;
}
.menu .content1 .logo a {
  text-decoration: none;
  font-size: 20px;
  color: seagreen;
  font-weight: bold;
}
.menu .content1 .btn {
  /* float: right; */
  width: auto;
}
.menu .content1 .btn ul {
  margin: 0;
  padding: 0;
  list-style: none;
}
.menu .content1 .btn ul li {
  float: left;
  padding: 0 20px;
  line-height: 50px;
}
.menu .content1 .btn ul li.ww {
  color: #ccc;
}
.menu .content1 .btn ul li a {
  text-decoration: none;
  color: #333;
  font-size: 14px;
}
.menu .content1 .btn ul li:nth-child(1) a {
  color: #000;
  font-weight: 700;
}
.menu .content1 .btn .el-menu.el-menu--horizontal {
  border: none;
}
.contenter {
  width: 1140px;
  margin: 0 auto 20px auto;
  /* height: 500px; */
  box-shadow: 0 0 10px #bbb;
  padding: 0 30px 40px 30px;
  background: #fff;
}
.contenter .ttitle {
  height: 70px;
  width: 100%;
  border-bottom: 1px solid #ccc;
  line-height: 70px;
  font-size: 18px;
  display: flex;
  color: seagreen;
  font-weight: bold;
}
.contenter .ttitle img {
  margin: 20px 10px;
}
.contenter .title {
  height: 70px;
  width: 100%;
  /* border: 1px solid red; */
  line-height: 70px;
  font-size: 16px;
  font-weight: bold;
  color: seagreen;
  padding: 0 0 0 20px;
}
.contenter .title .el-icon-document {
  margin-right: 10px;
  font-size: 20px;
  /* line-height: 30px; */
  color: seagreen;
  font-weight: bold;
}
.contenter .des {
  /* background: #eef6f0; */
  color: #555;
  line-height: 25px;
  padding: 5px 20px;
  font-size: 14px;
  text-indent: 30px;
}
.contenter .des1 {
  /* background: #eef6f0; */
  color: #555;
  line-height: 25px;
  padding: 5px 20px;
  font-size: 14px;
  text-indent: 30px;
}
.contenter .img {
  text-align: center;
  margin-top: 20px;
  font-size: 14px;
  line-height: 25px;
  overflow: auto;
  /* border: 1px solid red; */
  padding-bottom: 30px;
}
</style>
